import {
  faHome,
  faMusic,
  faUsers,
  faCalendarAlt,
  faHeartBroken,
  faChevronLeft,
  faStar,
  faClock,
  faCloud,
  faBolt,
  faUserGroup,
  faLocationDot,
  faIdCard,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useNavigate } from 'react-router-dom';
import { Button } from 'components/Button';
import styles from './NotFound.scss';

export const NotFound = () => {
  const navigate = useNavigate();
  const icons = [
    faMusic,
    faUsers,
    faHeartBroken,
    faCalendarAlt,
    faStar,
    faClock,
    faCloud,
    faBolt,
    faUserGroup,
    faLocationDot,
    faIdCard,
  ];

  const generateIcons = (count) => {
    const minDistance = 8;
    const iconsArray = [];

    const isFarEnough = (top, left) => {
      return iconsArray.every((i) => {
        const dx = parseFloat(i.left) - parseFloat(left);
        const dy = parseFloat(i.top) - parseFloat(top);
        return Math.sqrt(dx * dx + dy * dy) >= minDistance;
      });
    };

    for (let i = 0; i < count; i++) {
      let top, left;
      let attempts = 0;
      do {
        top = `${Math.random() * 95}%`;
        left = `${Math.random() * 97}%`;
        attempts++;
      } while (!isFarEnough(top, left) && attempts < 100);

      iconsArray.push({
        icon: icons[Math.floor(Math.random() * icons.length)],
        top,
        left,
        delay: `${(Math.random() * 3).toFixed(2)}s`,
      });
    }

    return iconsArray;
  };

  const backgroundIcons = generateIcons(30);

  return (
    <div className={styles.container}>
      <div className={styles.backgroundElements}>
        {backgroundIcons.map((item, index) => (
          <FontAwesomeIcon
            key={index}
            icon={item.icon}
            className={styles.dancingIcon}
            style={{
              top: item.top,
              left: item.left,
              animationDelay: item.delay,
            }}
          />
        ))}
      </div>

      <div className={styles.content}>
        <h1 className={styles.errorCode}>404</h1>
        <h2 className={styles.title}>Сторінку не знайдено</h2>
        <p className={styles.subtitle}>
          Схоже, ця сторінка пішла танцювати і не повернулася. Але не хвилюйтесь — в нашій CRM системі є багато інших
          розділів
        </p>

        <div className={styles.buttonsContainer}>
          <Button className={styles.button} onClick={() => navigate(-1)} ghostStyle>
            <FontAwesomeIcon icon={faChevronLeft} />
            Повернутися
          </Button>
          <Button className={styles.button} onClick={() => navigate('/')}>
            <FontAwesomeIcon icon={faHome} />
            На головну
          </Button>
        </div>
      </div>
    </div>
  );
};
